export const MANAGE_INVENTORY_VENDOR_ID = "MANAGE_INVENTORY_VENDOR_ID";
export const MANAGE_INVENTORY_TABNAME = "MANAGE_INVENTORY_TABNAME";
export const VENDOR_PROFILE_PAGE_NAME = "VENDOR_PROFILE_PAGE_NAME";
export const BIND_ACTIVE_PAGE_NAME = "BIND_ACTIVE_PAGE_NAME";
